import React from 'react';
import { FlapHeader } from "components/layout/";
import { FilterInputDate } from "components/pages/analytics-page/dashboard/dashboard-view";
import Utils, { SUPERVISION_SYNC_DELAY_OPTIONS } from "utils";
import { DropdownTemplate, WithLoadingComponent } from 'components/shared';
import { useHistory } from 'react-router';
import { SupervisorService } from 'services/http';
import { FlexLoader } from 'components/pages/analytics-page/dashboard/dimensions-filter';

/**
 * Tasks Supervision main component
 * @returns React.Component
 */
export const SupervisorIntervention = () => {
    return <>
        <FlapHeader
            primeary
            justify
            className="mx-0"
            leftSide={<span className="pt-1">Interventions Supervision</span>}
            rightSide={<SupervisionFilter />}
        />
        <TaskSupervisionSetHoc />
    </>
}

/**
 * Wrapped compoenent for tasks supervision
 * @param {Object} props Object to be populated from hoc component
 * @returns React.Component
 */
const TasksSupervisionWrapper = (props) => {
    const data = Utils.bindTasksSupervisionSet(props.data);
    /**
     * Intervention template component for recap stats by status
     * @param {Object} taskObject: Intervention stats object as props including status, count, icon, color
     * @returns React.Component
     */
    const SupervisionItem = ({ status, count, icon, color }) => {
        return (
            <div className='card shadow m-2'>
                <div className='card-body' style={{ padding: '0.75rem' }}>
                    <div className='d-flex'>
                        <div className='px-2 py-1 rounded' style={{ color: color, border: `1px solid ${color}` }}>
                            <i className={icon} style={{ fontSize: '1.5rem' }} />
                        </div>
                        <div className='mx-2'>
                            <div>{status}</div>
                            <strong>{count}+ </strong>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {data.length ? <div className='m-3' style={{ display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                {data.map(item => {
                    return <SupervisionItem {...item} />
                })}
            </div> : <div className='mt-5'>{Utils.NoItemsTemplate()}</div>}
        </>
    );
}

/**
 * High Order Component for tasks supervision 
 * @returns React.Component
 */
const TaskSupervisionSetHoc = () => {
    let filterSearchParam = JSON.parse(new URLSearchParams(window.location.search).get('filter'));
    let [syncRefresh, setSyncRefresh] = React.useState();
    if (filterSearchParam?.canal === "all") delete filterSearchParam.canal;

    //Set auto refresh trigger
    React.useEffect(() => {
        let interId = window.setInterval(() => {
            setSyncRefresh(Math.random());
        }, JSON.parse(new URLSearchParams(window.location.search).get('filter'))?.delay || SUPERVISION_SYNC_DELAY_OPTIONS[0].key);
        return () => { clearInterval(interId) }
    }, [filterSearchParam]);

    const Hoc = React.useMemo(() =>
        WithLoadingComponent(TasksSupervisionWrapper,
            () => SupervisorService.getRecapInterventionsByStatus(Utils.buildFilterCriteria(filterSearchParam)),
            <FlexLoader />)(),
        [filterSearchParam?.startDate, filterSearchParam?.endDate, filterSearchParam?.canal, syncRefresh]);
    return <Hoc />
}

/**
 * Tasks Supervision filterSet component
 * @returns React.Component
 */
export const SupervisionFilter = () => {
    const history = useHistory();
    const filterSearchParam = JSON.parse(new URLSearchParams(window.location.search).get("filter"));
    const [filter, setFilter] = React.useState(filterSearchParam
        || {
        canal: Utils.TASKS_SUPERVISION_SOURCE_OPTIONS[1].key,
        delay: SUPERVISION_SYNC_DELAY_OPTIONS[0].key,
        //startDate: Utils.getRangeDatesOfLastMonth().startDate,
        //endDate: Utils.getRangeDatesOfLastMonth().endDate
    });

    React.useEffect(() => {
        Object.keys(filter).length && Utils.pushURLSearchParams(history, "filter", JSON.stringify({ ...filter }));
    }, [filter]);

    return (
        <aside className="d-flex">
            <div className='d-flex'>
                <small className='m-2 text-nowrap'>Canal</small>
                <DropdownTemplate
                    options={Utils.TASKS_SUPERVISION_SOURCE_OPTIONS}
                    selectedItem={filter.canal}
                    optionLabel="label"
                    optionValue="key"
                    className="sm-dropdown mr-3"
                    scrollHeight={200}
                    height={"32px"}
                    onItemChange={(e) => { setFilter({ ...filter, canal: e.value }) }}
                />
            </div>

            <FilterInputDate
                label="From"
                value={filter.startDate}
                onChange={(e) => setFilter({ ...filter, startDate: e.target.value })}
            />

            <FilterInputDate
                label="To"
                value={filter.endDate}
                onChange={(e) => setFilter({ ...filter, endDate: e.target.value })}
            />

            <div className='d-flex'>
                <small className='m-2 text-nowrap'>Delay Sync</small>
                <DropdownTemplate
                    options={SUPERVISION_SYNC_DELAY_OPTIONS}
                    selectedItem={filter.delay}
                    optionLabel="label"
                    optionValue="key"
                    className="sm-dropdown mr-3"
                    scrollHeight={200}
                    height={"32px"}
                    onItemChange={(e) => { setFilter({ ...filter, delay: e.value }) }}
                />
            </div>
        </aside>
    );
}